/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { ExternalLinkButton } from "../../components/ExternalLinkButton";
import { colors } from "../../components/colors";
import * as authSelectors from "../auth/authSelectors";
import { heapsGoAdminReportsUrl } from "./heapsgo-admin-links";

const bodyStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 0 24px 24px 24px;
`;

// Signpost at the old reports URL, for bookmarks and muscle memory. The
// reports page itself was removed from this admin.
export const ReportsMoved = () => {
  const organizationKeyName =
    useSelector(authSelectors.selectedOrganizationKeyName) || "";

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Reports have moved"
          subtitle="Sales reports, order and product exports, and scheduled exports are now in the new admin."
        />
        <div css={bodyStyle}>
          {/* Our own admin: keep the referrer, so the new admin can tell
              visits that came from here. */}
          <ExternalLinkButton
            href={heapsGoAdminReportsUrl(organizationKeyName)}
            rel="noopener"
            text="Open reports in the new admin"
            icon={
              <FontAwesomeIcon icon={solid("arrow-up-right-from-square")} />
            }
            backgroundColor={colors.ctaMain}
            hoverColor={colors.ctaSecondaryOne}
            textColor={colors.white}
            width="fit-content"
          />
        </div>
      </CardContainer>
    </PageWrapper>
  );
};
